import { LEADER_ADDRESS_DETAIL_FRAGMENT } from '@/graphql/fragments/addressDetail'
import { gql } from '@apollo/client'

export const CONTACT_FRAGMENT = gql`
  fragment ContactFragment on Contact {
    id
    securityToken
    email
    firstname
    lastname
    fullName
    phoneNumber
    addressDetail {
      ...LeaderAddressDetailFragment
    }
  }
  ${LEADER_ADDRESS_DETAIL_FRAGMENT}
`
